import { render, staticRenderFns } from "./SecondNewPromo2.vue?vue&type=template&id=4f79d6b1&scoped=true"
import script from "./SecondNewPromo2.vue?vue&type=script&lang=js"
export * from "./SecondNewPromo2.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SecondNewPromo2.vue?vue&type=style&index=1&id=4f79d6b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f79d6b1",
  null
  
)

export default component.exports